import React, {useEffect, useRef, useState} from 'react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';

// @ts-ignore
import css from "../sectionSlider.module.scss";
import SectionInfrostrukture from "../section-infrostrukture";
import {useIsMobile} from "../../../helpers/helpers";
import {Swiper, SwiperSlide} from "swiper/react";
import {EffectFade, Navigation, Pagination} from "swiper/modules";

const SectionSliderPreview = ({data, hcDesc, mapData, images, hasDownloadRoute}) => {
    const isMobile = useIsMobile(); // по умолчанию 768px
    const sliderRef = useRef<any>(null);
    const sliderInfoRef = useRef<any>(null);
    const [hover, setHover] = useState(false)
    const [currentSlide, setCurrentSlide] = useState(1);
    const [coordinates] = useState({
        latitude: data.housing_complex?.apartments[0]?.housing_complex.latitude,
        longitude: data.housing_complex?.apartments[0]?.housing_complex.longitude,
    })

    const handlePaginationClick = (index: number) => {
        if (sliderRef.current) {
            sliderRef.current.swiper.slideTo(index);
            setCurrentSlide(index + 1);
        }
    };

    useEffect(() => {
        const el = sliderRef.current;

        if (el) {
            const handleEnter = () => setHover(true);
            const handleLeave = () => setHover(false);

            el.addEventListener('mouseenter', handleEnter);
            el.addEventListener('mouseleave', handleLeave);

            return () => {
                el.removeEventListener('mouseenter', handleEnter);
                el.removeEventListener('mouseleave', handleLeave);
            };
        }
    }, []);

    useEffect(() => {
        if (isMobile || hasDownloadRoute) return;

        const sliderInfoHeight = sliderInfoRef.current.clientHeight;
        const sliderPagination = sliderRef.current.querySelector('.swiper-pagination');

        sliderPagination.style.cssText = `
            bottom: ${sliderInfoHeight + 10}px
        `
    }, [sliderInfoRef, isMobile]);

    return (
        <div className={css.sectionSlider}>
            <Swiper
                onSlideChange={(swiper) => setCurrentSlide(swiper.activeIndex + 1)}
                navigation={true}
                spaceBetween={0}
                slidesPerView={1}
                pagination={{
                    clickable: true,
                    type: 'fraction', // Тип фракции для основной пагинации
                }}
                grabCursor={true}
                modules={[EffectFade, Pagination, Navigation]}
                ref={sliderRef}
            >
                {images.map((src, i) => (
                    <SwiperSlide key={i}>
                        <div
                            className="w-full h-full bg-cover"
                            style={{
                                backgroundImage: `url(${src.links.original})`,
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center center',
                            }}
                        />
                    </SwiperSlide>
                ))}
                <div className={css.sectionSliderInfo} ref={sliderInfoRef}>
                    {/* Кастомная пагинация для мобильных */}
                    {isMobile && (
                        <div className={css.customPaginationContainer}>
                            <div className={css.customPagination}>
                                {images.map((_, index) => (
                                    <div
                                        key={index}
                                        className={`${css.customBullet} ${currentSlide === index + 1 ? css.active : ''}`}
                                        onClick={() => handlePaginationClick(index)}
                                    />
                                ))}
                            </div>
                        </div>
                    )}
                    <p className={css.sectionSliderInfo__header}>
                        {data.housing_complex?.housing_complex_name}
                    </p>
                    <p className={css.sectionSliderInfo__text}>
                        {hcDesc.address}
                    </p>
                    <p className={css.sectionSliderInfo__text}>
                            <span className={css.sectionSliderInfoTextCount}>
                                {hcDesc.lots}
                            </span>
                    </p>
                </div>
            </Swiper>
            <SectionInfrostrukture
                data={coordinates}
                hcDesc={hcDesc}
                mapData={mapData}
            />
        </div>
    );
};

export default SectionSliderPreview;